module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp12_4.1dbf8b41.png";